/* Vermiviva: aparicion suave al hacer scroll */
(function () {
  var els = document.querySelectorAll('.vv-reveal');
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0.12 });
  els.forEach(function (e) { io.observe(e); });
})();

/* Vermiviva: entrada escalonada de elementos hermanos */
(function () {
  var seen = new Set();
  document.querySelectorAll('.vv-reveal').forEach(function (e) {
    var p = e.parentElement; if (!p || seen.has(p)) return; seen.add(p);
    var kids = [].filter.call(p.children, function (c) { return c.classList.contains('vv-reveal') && !c.style.transitionDelay; });
    if (kids.length > 1) kids.forEach(function (c, i) { c.style.transitionDelay = Math.min(i, 5) * 0.09 + 's'; });
  });
})();
